import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=ff1e98f8&scoped=true&"
import script from "./CheckBox.vue?vue&type=script&lang=ts&"
export * from "./CheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=ff1e98f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1e98f8",
  null
  
)

export default component.exports